var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgMusicaEHobbies = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03406 9.15316L8.47107 9.0761V16.3021C7.83579 15.6538 6.95038 15.2515 5.97107 15.2515C4.03818 15.2515 2.47107 16.8186 2.47107 18.7515C2.47107 20.6844 4.03818 22.2515 5.97107 22.2515C7.90396 22.2515 9.47107 20.6844 9.47107 18.7515V8.89975L18.9711 7.22445V14.8021C18.3358 14.1538 17.4504 13.7515 16.4711 13.7515C14.5382 13.7515 12.9711 15.3186 12.9711 17.2515C12.9711 19.1844 14.5382 20.7515 16.4711 20.7515C18.404 20.7515 19.9711 19.1844 19.9711 17.2515V6.82663C20.5508 6.38834 20.8703 5.64829 20.7359 4.88349L20.4748 3.40554C20.2828 2.31735 19.2452 1.59072 18.1573 1.78371L7.07887 3.73661C5.99083 3.92862 5.26479 4.96573 5.45678 6.05366L5.71701 7.5303C5.90903 8.61844 6.9462 9.34514 8.03406 9.15316ZM18.9711 17.2515C18.9711 15.8709 17.8517 14.7515 16.4711 14.7515C15.0905 14.7515 13.9711 15.8709 13.9711 17.2515C13.9711 18.6321 15.0905 19.7515 16.4711 19.7515C17.8517 19.7515 18.9711 18.6321 18.9711 17.2515ZM5.97107 16.2515C7.35168 16.2515 8.47107 17.3709 8.47107 18.7515C8.47107 20.1321 7.35168 21.2515 5.97107 21.2515C4.59046 21.2515 3.47107 20.1321 3.47107 18.7515C3.47107 17.3709 4.59046 16.2515 5.97107 16.2515ZM19.751 5.05603C19.8465 5.59937 19.4832 6.11818 18.9393 6.21365L7.86034 8.1674C7.31649 8.26337 6.79787 7.9 6.70181 7.35566L6.44158 5.87902C6.34556 5.33488 6.70848 4.81646 7.25256 4.72044L18.3315 2.76746C18.8755 2.67096 19.394 3.03409 19.49 3.57845L19.751 5.05603Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }));
};
export default SvgMusicaEHobbies;